export const FETCH_INIT_SPECIAL_OFFERS = 'fetch_init_special_offers',
    FETCH_SPECIAL_OFFERS = 'fetch_special_offers',
    FETCH_SPECIAL_OFFERS_SUCCESS = 'fetch_special_offers_success',
    FETCH_SPECIAL_OFFERS_ERROR = 'fetch_special_offers_error',
    FETCH_SPECIAL_OFFER = 'fetch_special_offer',
    FETCH_SPECIAL_OFFER_SUCCESS = 'fetch_special_offer_success',
    FETCH_SPECIAL_OFFER_ERROR = 'fetch_special_offer_error',
    CREATE_SPECIAL_OFFER = 'create_special_offer',
    CREATE_SPECIAL_OFFER_SUCCESS = 'create_special_offer_success',
    CREATE_SPECIAL_OFFER_ERROR = 'create_special_offer_error',
    UPDATE_SPECIAL_OFFER = 'update_special_offer',
    UPDATE_SPECIAL_OFFER_SUCCESS = 'update_special_offer_success',
    UPDATE_SPECIAL_OFFER_ERROR = 'update_special_offer_error',
    ARCHIVE_SPECIAL_OFFER = 'archive_special_offer',
    ARCHIVE_SPECIAL_OFFER_SUCCESS = 'archive_special_offer_success',
    ARCHIVE_SPECIAL_OFFER_ERROR = 'archive_special_offer_error',
    FETCH_OFFER_YACHT_RATES = 'fetch_offer_yacht_rates',
    FETCH_OFFER_YACHT_RATES_SUCCESS = 'fetch_offer_yacht_rates_success',
    FETCH_OFFER_YACHT_RATES_ERROR = 'fetch_offer_yacht_rates_error',
    FETCH_OFFER_YACHT_SEASONS_SUCCESS = 'fetch_offer_yacht_seasons_success';
